import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

// Datos de /api/parametros (Panel de Parametrización, guía 7.11).

interface SettingBase {
  key: string;
  module: string;
  label: string;
  description: string;
  isDefault: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
}

export type Setting = SettingBase &
  (
    | { type: 'integer'; value: number; default: number; min: number; max: number; unit?: string }
    | { type: 'boolean'; value: boolean; default: boolean }
    | { type: 'time'; value: string; default: string }
    | { type: 'text'; value: string; default: string; maxLength: number }
    | { type: 'enum'; value: string; default: string; options: Array<{ value: string; label: string }> }
  );

export interface CatalogOption {
  value: string;
  label: string;
}

/** Campo de un catálogo, tal como lo describe la API (la pantalla se arma con esto). */
export type CatalogField = {
  name: string;
  label: string;
  required?: boolean;
  help?: string;
  /** No se cambia después de crear el registro. */
  immutable?: boolean;
} & (
  | { type: 'text'; maxLength?: number; format?: 'url' }
  | { type: 'integer' | 'decimal'; min?: number; max?: number }
  | { type: 'boolean' }
  | { type: 'color' }
  | { type: 'select' | 'reference'; options: CatalogOption[]; nullLabel?: string }
);

export interface CatalogInfo {
  key: string;
  title: string;
  description: string;
  module: string;
  fields: CatalogField[];
}

export type CatalogItem = Record<string, unknown> & { id: string; active: boolean; sortOrder: number };

export const KEYS = {
  valores: ['parametros', 'valores'] as const,
  catalogos: ['parametros', 'catalogos'] as const,
  items: (key: string) => ['parametros', 'catalogo', key] as const,
};

export const useCatalogs = () => useQuery({ queryKey: KEYS.catalogos, queryFn: () => api<CatalogInfo[]>('/api/parametros/catalogos') });
